

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from '@/locale/en'
import ko from '@/locale/ko'
import jp from '@/locale/jp'
import es from '@/locale/es'
import pt from '@/locale/pt'
import zhHant from '@/locale/zhHant'

Vue.use(VueI18n)

export default new VueI18n({
  locale: sessionStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    ko,
    jp,
    es,
    pt,
    zhHant
  }
})
